import { Component, OnInit } from '@angular/core';
import { AnnouncementService, config, MemberDetails, MemberQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Populations } from 'src/app/shared/utilities/populations';

import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  config = config;
  screenSize = ScreenType;
  productCode = ProductCode;
  populations = Populations;
  name$: Observable<string>;
  memberDetails$: Observable<MemberDetails | undefined>;

  constructor(private announcementService: AnnouncementService, private memberQuery: MemberQuery) {}

  ngOnInit() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `${m.FirstName}`;
        }
        return '';
      })
    );

    // let notSeenModal = this.cookieService.get(modalCookieName) !== 'true';

    // if (window.matchMedia('(max-width: 991px)').matches && notSeenModal) {
    //   let userAgent = navigator.userAgent;
    //   setTimeout(() => {
    //     // android detection
    //     if (/android/i.test(userAgent)) {
    //       this.openModal('popup-add-to-home-screen-android-modal-window', 'android');
    //     }
    //     // iOS detection
    //     if (/iPad|iPhone|iPod/g.test(userAgent)) {
    //       this.openModal('popup-add-to-home-screen-ios-modal-window', 'ios');
    //     }
    //   }, 3000);
    // }
    firstValueFrom(this.announcementService.fetchAnnouncements());
  }

  // private openModal(windowClass: string, deviceType: 'android' | 'ios') {
  //   const modalRef = this.modalService.open(PopupAddToHomeScreenComponent, {
  //     windowClass: windowClass,
  //     modalDialogClass: 'popup-add-to-home-screen-dialog',
  //     ariaLabelledBy: 'modal-basic-title',
  //     backdrop: false,
  //   });
  //   modalRef.componentInstance.detectedDevice = deviceType;

  //   modalRef.dismissed
  //     .pipe(
  //       tap(() => {
  //         this.cookieService.set(modalCookieName, 'true', { expires: 365, sameSite: 'Strict' });
  //       }),
  //       takeUntilDestroyed(this.destoryRef)
  //     )
  //     .subscribe();
  // }
}
